'use client'

import type { HomeBannerPlacement, HomeBannersResponse } from '@entities/home-banners'
import { FEATURE_FLAG_KEYS } from '@shared/constants'

import { useFlagsCompat } from '@podo/flags/react'

import { ApiHomeBannerCarousel } from './api-home-banner-carousel'
import { LegacyHomeBannerCarousel } from './legacy-home-banner-carousel'

export {
  getBannerIndicatorState,
  HOME_BANNER_CONTAINER_CLASS_NAME,
  HOME_BANNER_IMAGE_PROPS,
} from './api-home-banner-carousel'

type HomeBannerCarouselProps = {
  countryCode?: string | null
  placement?: HomeBannerPlacement
  className?: string
  initialBanners?: HomeBannersResponse | null
}

export const HomeBannerCarousel = ({
  countryCode,
  placement = 'HOME',
  className,
  initialBanners,
}: HomeBannerCarouselProps) => {
  const { [FEATURE_FLAG_KEYS.HOME_BANNER_API_ENABLED]: homeBannerApiFlag } = useFlagsCompat([
    FEATURE_FLAG_KEYS.HOME_BANNER_API_ENABLED,
  ])

  if (placement === 'HOME' && !homeBannerApiFlag.enabled) {
    return <LegacyHomeBannerCarousel />
  }

  return (
    <ApiHomeBannerCarousel
      countryCode={countryCode}
      placement={placement}
      className={className}
      initialBanners={initialBanners}
    />
  )
}
